import NotFoundImage from "../../assets/img/404.png";
import { AGButton } from "../commerceLandingPage/commerceLandingPage.styled";

const PageNotFound = () => {
	return (
		<div
			style={{
				// backgroundColor: 'rgb(31, 103, 149)',
				color: "rgb(31, 103, 149)",
				textAlign: "center",
				padding: "50px",
			}}>
			<img
				src={NotFoundImage}
				alt="Page not found"
				style={{ width: "30%", marginBottom: "20px", margin: "auto" }}
			/>
			<b>Page Not Found</b>
			<p>We're sorry, the page you requested could not be found.</p>
			<AGButton className='!w-[260px]' onClick={()=>{window.location.href = "/"}}>Back to Commerce Marketplace</AGButton>
		</div>
	);
};

export default PageNotFound;
